import Head from 'next/head'
import { SessionProvider } from 'next-auth/react'
import AdminLayout from '@layouts/admin'
import { getConstant } from '@utils/constants'

import '@styles/(intranet)/styles.scss'
import ErrorBoundary from '@components/(debug)/error-boundary'
import Error from '@components/error'

export default function App({ Component, pageProps: { session, ...pageProps } }) {
  return (
    <>
      <Head>
        <title>{`${getConstant('sitename')} | FORTESEC`}</title>
        <meta name="description" content="Rede interna da Fortesec." />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <SessionProvider session={session}>
        <ErrorBoundary fallback={<Error title="500" message="Erro desconhecido. Por favor, entre em contato com a TI." />}>
          <AdminLayout auth={Component?.auth} groups={Component?.groups} container={Component?.container}>
            <Component {...pageProps} />
          </AdminLayout>
        </ErrorBoundary>
      </SessionProvider>
    </>
  );
}
